import { ReassignmentCardBase } from './base'

interface ReassignmentRequestedCardProps {
  effectiveDate: string
  requesterType: string
  canTakeAction: boolean
  onReviewClick?: () => void
  onViewDetailsClick?: () => void
}

export function ReassignmentRequestedCard({
  effectiveDate,
  requesterType,
  canTakeAction,
  onReviewClick,
  onViewDetailsClick,
}: ReassignmentRequestedCardProps) {
  const subtitle = `Effective ${effectiveDate} | ${requesterType}`
  const actionButton =
    canTakeAction && onReviewClick ? { label: 'Review Request', onClick: onReviewClick } : undefined

  return (
    <ReassignmentCardBase
      title="Reassignment Requested"
      subtitle={subtitle}
      actionButton={actionButton}
      onViewDetailsClick={onViewDetailsClick}
    />
  )
}
